export const getAllFlights = state => (state ? state.toJS() : null);

export const getAllFlightsByRouteId = (state, routeId) =>
  state.find(flight => flight.routeId === routeId);



// WEBPACK FOOTER //
// ./src/redux/selectors/AllFlightsSelectors.js